import { metaKey } from '~/scripts/utils';
import { underscore } from 'inflected';

export default async ({ $api, route, store }) => {
  let product;
  if (route.name.includes('life-insurance', 'mortgage-protection', 'serious-illness')) {
    product = underscore(store.getters['products/getCoverType'].product);
  } else {
    product = underscore(metaKey(route, 'product').split('/').pop());
  }
  if (product) {
    await $api('providers/providers/slugs', { product }).then(providerSlugs => {
      store.commit('providers/setList', providerSlugs);
    });
  }
};
